import { useTranslation } from 'react-i18next';

import { DataPanelInlineItem } from '@/ui';
import { openEditCallSignDialog } from '../../actions';

export type AdditionalIncidentDataPanelItemProps = {
  incidentId: string;
  incidentIsReadOnly: boolean;
  callSign: string | null;
};

export function AdditionalIncidentDataPanelItem({
  incidentId,
  incidentIsReadOnly,
  callSign,
}: AdditionalIncidentDataPanelItemProps) {
  const { t } = useTranslation();

  return (
    <DataPanelInlineItem
      title={t('Incident_InfoPanel_CallSign')}
      value={callSign ?? undefined}
      editable={!incidentIsReadOnly}
      showEmptyPlaceholder
      onEditClick={() => openEditCallSignDialog(incidentId, callSign)}
    />
  );
}
